import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import FranchiseSidebar from './FranchiseSidebar';

const FranchiseLayout = () => {
    const { isAuthenticated, isFranchiseAdmin, loading } = useAuth();

    if (loading) {
        return <div className="loading-screen"><div className="spinner"></div></div>;
    }

    if (!isAuthenticated || !isFranchiseAdmin) {
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <div className="admin-layout" style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
            <FranchiseSidebar />
            <main className="admin-main" style={{ flex: 1, padding: '20px', overflowY: 'auto' }}>
                <Outlet />
            </main>
        </div>
    );
};

export default FranchiseLayout;
